module.exports = __webpack_public_path__ + "img/icon5.4b939f45.gif";